import styled from "styled-components";

const ErrorText = styled.p`
    margin: 0;
    font-size: 14px;
    color: #e74c3c
`;

export default ErrorText;
